import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=f33d1c90&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=f33d1c90&prod&lang=scss&"
import style1 from "./detail.vue?vue&type=style&index=1&id=f33d1c90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports